import React from 'react';
import styles from '../layout.module.scss';
export const Footer = ({ children }) => (React.createElement("footer", { className: styles.pageFooter }, children));
//# sourceMappingURL=footer.js.map